/* eslint-disable no-param-reassign */

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import DataTable from "components/Tables/DataTable";
import { toast } from "react-toastify";
import contractorRows from "layouts/contractors/data/contractors";
import MDButton from "components/MDButton";
import { Icon } from "@mui/material";
import { actions } from "../../store/reducers/contractors";
import Modal from "./modal";

function Contractors() {
  const { getRows, columns } = contractorRows();
  const dispatch = useDispatch();
  const [contractorToEdit, setContractorToEdit] = useState(null);

  const {
    contractors,
    totalItems,
    page,
    perPage,
    qs,
    initialFetchIsDone,
    locations,
    jobs,
    companies,
    typeCodes,
  } = useSelector((state) => state.contractors);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setContractorToEdit(null);
  };

  const submit = useCallback(
    (data, call) => {
      if (contractorToEdit) {
        dispatch(
          actions.updateContractor(
            contractorToEdit.id,
            data,
            () => {
              toast.success("Contractor updated successfully");
              handleClose();
            },
            (msg, error) => {
              toast.error(msg || "Contractor could not be updated");
              call(error);
            }
          )
        );
      } else {
        dispatch(
          actions.addContractor(
            data,
            () => {
              toast.success("Contractor created successfully");
              handleClose();
            },
            (msg, error) => {
              toast.error(msg || "Contractor could not be created");
              call(error);
            }
          )
        );
      }
    },
    [contractorToEdit, dispatch, handleClose]
  );

  useEffect(() => {
    if (!initialFetchIsDone) {
      dispatch(actions.fetchContractorLocationRequest((err) => toast.error(err)));
      dispatch(actions.fetchCompaniesLocationRequest((err) => toast.error(err)));
      dispatch(actions.fetchContractorJobsRequest((err) => toast.error(err)));
      dispatch(actions.fetchContractorTypeCodesRequest((err) => toast.error(err)));
    }
  }, []);

  useEffect(() => {
    dispatch(actions.fetchContractorRequest(page, perPage, (err) => toast.error(err)));
  }, [page, perPage, qs]);

  const rows = useMemo(
    () =>
      getRows(
        contractors,
        locations.reduce((all, l) => {
          all[l.id] = l;
          return all;
        }, {}),
        jobs.reduce((all, l) => {
          all[l.id] = l;
          return all;
        }, {}),
        companies.reduce((all, l) => {
          all[l.id] = l;
          return all;
        }, {}),
        setContractorToEdit
      ),
    [locations, contractors, jobs, companies]
  );
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Contractors
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <MDBox pl={3}>
                  <MDButton
                    variant="gradient"
                    color="primary"
                    size="medium"
                    aria-label="close"
                    onClick={handleOpen}
                  >
                    <Icon fontSize="medium">add</Icon> Add Contractor
                  </MDButton>
                </MDBox>
                <DataTable
                  entriesPerPage={{ defaultValue: perPage, entries: [5, 10, 15, 20, 50] }}
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries
                  noEndBorder
                  canSearch
                  totalCount={totalItems}
                  page={page}
                  perPage={perPage}
                  qs={qs}
                  setQs={(s) => dispatch(actions.setContractorQs(s))}
                  gotoPage={(p) => dispatch(actions.setContractorPage(p))}
                  setPageSize={(p) => dispatch(actions.setContractorPerPage(p))}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Modal
        open={!!(open || contractorToEdit)}
        handleClose={handleClose}
        onSumbit={submit}
        locations={locations}
        jobs={jobs}
        companies={companies}
        typeCodes={typeCodes}
        data={contractorToEdit}
        isEdit={contractorToEdit !== null}
      />
    </DashboardLayout>
  );
}

export default Contractors;
